import {SignalRObserver} from "@share/web-conferences/interfaces/signalr/SignalRObserver";
import {ObserverData} from "@share/web-conferences/interfaces/signalr/ObserverData";
import {ObserverMethods, Observers} from "@api/repositories/reatime-repository/types";

export class SignalRHelper {
    private readonly realTimeObservers: Observers;

    connected: boolean;

    constructor(
        private readonly data: ObserverData,
        private readonly observers: SignalRObserver[]
    ) {
        const handlers: ObserverMethods = {};

        observers.forEach(item => {
            handlers[item.method] = item.callback.bind(item);
        })

        this.realTimeObservers = {
            [this.channelName]: handlers
        }
    }

    get lang(): string {
        return this.data.store.state.session?.language ?? 'en';
    }

    get channelName(): string {
        return `WebConference.${this.data.schemaId}.${this.data.objectId}.${this.lang}`;
    }

    public async connectToHub(observers: Observers | null= null) {
        if(this.connected) {
            return;
        }
        const connectResult: Record<string, any> = await this.data.realtimeRepository.attach(observers ? observers : this.realTimeObservers);
        for (let [method, data] of Object.entries(connectResult)) {
            const observer = this.observers.find(observer => observer.method == method);
            if (observer) {
                await observer.processConnect(data);

            }
        }

        this.connected = true;
    }

    //@todo check if not using this and remove
    public async addObserverAndConnect(observer: SignalRObserver) {
        this.realTimeObservers[this.channelName][observer.method] = observer.callback.bind(observer);
        const realTimeObserversForConnect = {
            [this.channelName]: {
                [observer.method]: this.realTimeObservers[this.channelName][observer.method]
            }
        }
        await this.connectToHub(realTimeObserversForConnect);
    }

    public async disconnectFromHub() {
        await this.data.realtimeRepository.detach(this.realTimeObservers);
    }
}
